// Whether the screen is phone-width — for the few places where a phone gets a different
// CONTROL rather than the same one restyled (a list's rows become a stacked list, and a
// row opens a sheet instead of a menu). Layout alone stays in CSS. The breakpoint is the
// shell's own (responsive.css, dsShell.css): where the sidebar becomes a drawer.
import { useEffect, useState } from 'react';

const QUERY = '(max-width: 760px)';

const matches = () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(QUERY).matches : false);

export default function useIsPhone() {
  const [phone, setPhone] = useState(matches);
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const media = window.matchMedia(QUERY);
    const on = () => setPhone(media.matches);
    media.addEventListener('change', on);
    return () => media.removeEventListener('change', on);
  }, []);
  return phone;
}
